<!-- eslint-disable -->
<template lang="pug">
    .row.user-preview(
        :class="userPreviewClasses"
    )
        .col-xs-12.col-md-2.col-xl-1.user-preview__column.user-preview__column_with-trophy(:class="getColor(place)")
            i.fa.fa-trophy(v-if="place < 4", :class="color")
            span.user-preview__place {{ place }}
        .row.col-xs-12.col-md-8.col-xl-11
            .col-xs-12.col-xl-6.user-preview__column
                small-user-preview(:displayed-user="student")
                    .user-info(slot="info")
                        .user-info(v-for="school in student.schools" :key="school.id" )
                            svg-icon.user-preview__icon(name="university")
                            template(v-if="school")
                                router-link.user-preview__link.preview__text(
                                    v-if="user.type !== 'student'"
                                    :to="{name: 'school:profile', params: {id: school.id}}"
                                )
                                    | {{ school.name }}
                                .preview__text(v-else)
                                    | {{ school.name }}
                            template(v-else)
                                | {{ $i18n.t('list.list_common_noSchool') }}
                            .user-info(
                                v-if="schoolGrades(school).length"
                                v-for="grade in schoolGrades(school)"
                            )
                                svg-icon.user-preview__icon(name="list-inverse")
                                router-link.user-preview__link.preview__text(
                                    :to="{name: 'grade:profile', params: {id: grade.id}}"
                                )
                                    | {{ grade.name }}
                            div(v-else)
                                | {{ $i18n.t('list.list_common_noGrade') }}
            .col-xs-12.col-xl-6.user-preview__column
                .row.user-preview__info
                    .col-xs-2.info__column
                        svg-icon.user-preview__icon(name="goal")
                        .preview__text {{ battleRating.systemPlace > 500 ? '500+' : battleRating.systemPlace }}
                        .preview__help {{ $i18n.t('battle.battle_rating_list_helpWorldPlace') }}
                    .col-xs-2.info__column
                        svg-icon.user-preview__icon(name="university")
                        .preview__text {{ battleRating.schoolPlace }}
                        .preview__help {{ $i18n.t('battle.battle_rating_list_helpSchoolPlace') }}
                    .col-xs-2.info__column
                        svg-icon.user-preview__icon(name="tablet")
                        .preview__text {{ battleRating.gradePlace }}
                        .preview__help {{ $i18n.t('battle.battle_rating_list_helpGradePlace') }}
                    .col-xs-2.info__column
                        svg-icon.user-preview__icon(name="circle-check")
                        .preview__text {{ battleRating.victoryAmount }}
                        .preview__help {{ $i18n.t('battle.battle_rating_list_helpVictories') }}
                    .col-xs-2.info__column
                        svg-icon.user-preview__icon(name="circle-close")
                        .preview__text {{ battleRating.lossAmount }}
                        .preview__help {{ $i18n.t('battle.battle_rating_list_helpLosses') }}
                    .col-xs-2.info__column
                        svg-icon.user-preview__icon(name="star-fill")
                        .preview__text {{ battleRating.starsAmount }}
                        .preview__help {{ $i18n.t('battle.battle_rating_list_helpStars') }}

</template>

<script>
    /*eslint-disable*/
    import authentication from '../../../utils/user/authentication';
    import { mapState } from 'vuex';
    import SmallUserPreview from '../../profiles/default-elements/SmallUserPreview.vue';

    export default {
        props: {
            student: Object,
            battleRating: Object,
        },
        mixins: [authentication],
        components: {
            SmallUserPreview,
        },
        methods: {
            getColor (place) {
                return {
                    gold: place === 1,
                    silver: place === 2,
                    copper: place === 3
                };
            },
            schoolGrades (school) {
                return this.student.grades.filter(grade => grade.schoolId === school.id);
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
            color () {
                return this.getColor(this.place);
            },
            userPreviewClasses () {
                switch (this.place) {
                    case 1:
                        return 'user-preview--gold';
                    case 2:
                        return 'user-preview--silver';
                    case 3:
                        return 'user-preview--copper';
                    default:
                        return '';
                }
            },
            place () {
                return this.student.computedPosition;
            },
        }
    }
</script>

<style lang="scss" scoped>
    $gold: #FFAD1F;
    $silver: #858585;
    $copper: #A44020;

    .gold {
        color: $gold;
    }
    .silver {
        color: $silver;
    }
    .copper {
        color: $copper;
    }

    .user-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 8px 0;
        padding: 16px;
    }

    .user-preview--gold {
        border: 1px solid $gold;
    }

    .user-preview--silver {
        border: 1px solid $silver;
    }

    .user-preview--copper {
        border: 1px solid $copper;
    }

    .user-preview__place {
        font-size: 24px;
        line-height: 30px;
        text-align: center;
        margin-left: 10px;
    }

    .user-preview__icon {
        color: $hsl-color-green-58;
        &:hover ~ .preview__help {
            opacity: 1;
        }
    }

    .user-preview__column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
        margin-bottom: 16px;
        @include media($xlg) {
            margin-bottom: 0;
        }
    }

    .user-preview__column_with-trophy {
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .user-preview__column:last-child {
        margin-bottom: 0;
    }

    .user-preview__info {
        margin: -8px 0;
    }

    .info__column {
        position: relative;
        display: flex;
        align-items: center;
        padding: 8px 0;
    }

    .preview__text {
        margin-left: 8px;
    }

    .preview__help {
        position: absolute;
        top: 25px;
        right: -15px;
        width: 100px;
        height: auto;
        font-size: 14px;
        text-align: center;
        opacity: 0;
        transition: all .3s linear;
        cursor: default;
        @include media($sm) {
            right: 0
        }
        @include media($lg) {
            right: 20px;
        }
        @include media($xlg) {
            top: 35px;
            right: 25px;
            font-size: 16px;
        }
        @include media($xl) {
            right: 40px;
        }
    }

    .user-preview__link {
        text-decoration-line: underline;
        color: $x-color-black;
        &:hover {
            text-decoration-line: underline;
            color: $x-color-black;
        }
    }

    .user-info {
        margin-top: 8px;
    }
</style>
